"use client";
import cookies from 'js-cookie';
import React, { useCallback, useEffect, useMemo } from 'react';
import { COOKIES } from '@sravni/utils/lib/consts';
import { ATTR_NAME } from '@sravni/utils/lib/theme';
import { isBrowser } from '../../utils/dom.js';
import { COOKIE_MAX_AGE } from './consts.js';
import { ThemeContext } from './Context.js';

function ControlledThemeProvider(props) {
    const { theme, onChange, children } = props;
    const setTheme = useCallback(
    // isTrusted - true if function called by user action
    (theme, isTrusted = true) => {
        if (isTrusted) {
            cookies.set(COOKIES.USER_THEME, theme, {
                expires: new Date(new Date().getTime() + COOKIE_MAX_AGE),
                sameSite: 'Lax',
                path: '/',
            });
        }
        onChange(theme);
    }, [onChange]);
    useEffect(() => {
        if (!isBrowser) {
            return;
        }
        const node = document.documentElement;
        node?.setAttribute(ATTR_NAME, theme);
    }, [theme]);
    const value = useMemo(() => ({ theme, setTheme }), [setTheme, theme]);
    return React.createElement(ThemeContext.Provider, { value: value }, children);
}

export { ControlledThemeProvider };
//# sourceMappingURL=Controlled.js.map
